// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table.el-table--fit.el-table--enable-row-hover.el-table--enable-row-transition.el-table--medium::before{\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
